import './GlobalJQuery'; // must be first
// jQuery plugins
import 'jqueryui';
// @ts-expect-error no types
import 'jquery.autosize.min';
import '@sentry/browser';
import 'bootstrap';
// @ts-expect-error no types
import 'jquery.ajax-progress';
import 'd3';
import 'jquery.cookie';
import 'util/inlineeditable';

import 'polyfills';
import 'util/backbone-extensions';

// injected by webpack at production build time
if (global.__BUILD_TIMESTAMP__) {
  window.BUILD_TIMESTAMP = new Date(global.__BUILD_TIMESTAMP__);
}

export {};
